<template>
  <div class="container">
    <el-breadcrumb separator=">" class="title">
      <el-breadcrumb-item>教练管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row :gutter="10" class="search-wrapper">
      <el-col :span="7" style="padding-left: 0">
        <div class="grid-content">
          <el-input placeholder="" v-model="no">
            <template slot="prepend">证件号</template>
          </el-input>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="grid-content">
          <el-input placeholder="" v-model="name">
            <template slot="prepend">姓名</template>
          </el-input>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="grid-content">
          <el-input placeholder="" v-model="phoneNo">
            <template slot="prepend">手机号</template>
          </el-input>
        </div>
      </el-col>
      <el-col :span="3">
        <div class="grid-content">
          <el-button
            type="primary"
            @click="search"
          >查询
          </el-button>
        </div>
      </el-col>
    </el-row>
    <el-button
      type="primary"
      size="mini"
      class="add-btn"
      @click="goToAdd"
    >新增教练
    </el-button>
    <el-button
      type="primary"
      size="mini"
      class="add-btn"
      @click="goToAddes"
    >批量新增教练
    </el-button>
    <el-button
      type="primary"
      size="mini"
      class="add-btn"
      @click="downLoadFile"
    >下载批量添加模板
    </el-button>
    <el-table
      class="table"
      :data="coachList"
      :max-height="tableHeight"
      style="width: 100%">
      <el-table-column
        fixed="left"
        prop="no"
        label="证件号/No"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="nameEnglish"
        label="英文名字"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="phoneNo"
        label="手机号"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="disclosureDue"
        label="无犯罪证明到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="firstAidDue"
        label="急救到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="memberFeeDue"
        label="会费到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="qualifications1"
        label="教练等级"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="cpdDue1"
        label="cpd到期时间"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="qualifications2"
        label="教练等级2"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="cpdDue2"
        label="cpd到期时间2"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="qualifications3"
        label="教练等级3"
        align="center"
        width="150">
      </el-table-column>
      <el-table-column
        prop="cpdDue3"
        label="cpd到期时间3"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="isBlack"
        label="黑名单"
        align="center">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
          >修改
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @current-change="handleCurrentChange"
      prev-text="上一页"
      next-text="下一页"
      :current-page="currentPage"
      :page-size="pageSize"
      layout="total, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
  import { listType } from '@/common/js/config';
  import { getCoachList } from '@/api/coach';
  import { downLoadUrl } from '@/api/config';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'course_list',
    data() {
      return {
        no: '',
        name: '',
        phoneNo: '',
        currentPage: 1,
        total: 0,
        tableHeight: 500,
        pageSize: 3,
      };
    },
    created() {
      if (!this.$route.params.pageNum) {
        this.$router.push('/coach_list/1');
        this.currentPage = 1;
        this._getCoachList(1);
      } else {
        this._getCoachList(this.$route.params.pageNum);
        this.currentPage = parseInt(this.$route.params.pageNum);
      }
    },
    mounted() {
      let orderHeight = document.body.clientHeight;
      this.tableHeight = orderHeight - 284;
    },
    methods: {
      goToAdd() {
        this.$router.push('/add_coach');
      },
      downLoadFile() {
        window.location.href = downLoadUrl;
      },
      goToAddes() {
        this.$router.push('/add_coaches');
      },
      search() {
        this.$router.push('/coach_list/1');
        this.currentPage = 1;
        this._getCoachList(1);
      },
      handleEdit(index, item) {
        this.setItem({
          item,
          type: listType.COACH
        });
        this.$router.push({
          path: `/update_coach/${item.uuid}`
        });
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this._getCoachList(val);
      },
      _getCoachList(pageNum) {
        getCoachList(this.user.userId, pageNum, this.no, this.name, this.phoneNo).then((res) => {
          this.total = res.count;
          this.pageSize = res.pageSize;
          this.setList({
            list: res.instructors,
            type: listType.COACH
          });
        });
        this.$router.push(`/coach_list/${pageNum}`);
      },
      ...mapActions([
        'setList',
        'setItem'
      ])
    },
    computed: {
      ...mapGetters([
        'coachList',
        'user'
      ])
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    height: 100%;
    overflow: scroll;
    .title
      margin-bottom: 20px;
    .search-wrapper
      margin: 0 0 20px 0 !important;
    .add-btn
      margin-bottom: 20px;
    .table
      margin-bottom 10px;
</style>